"use strict";
import React from "react";
import Auth from "../util/auth";
import "../api/account";
import DisablingButton from "./disabling_button";
import { Flash } from "../components/flash";
import FormInput from "../util/form_input";
import presenceService from "./presence_service_next_gen";
import "../util/feature_flags";
import WaitingSpinner from "../components/waiting_spinner";
import { History } from "react-router";
import Reskin from "../helpers/reskin";
const LoginForm = React.createClass({
  mixins: [History],
  // LIFECYCLE
  getInitialState: function() {
    return {
      loading: true,
      loginError: null,
      sending: false,
      fetchingOktaStatus: false,
      oktaEnabled: null,
      password: null,
      showPasswordReset: false,
      sendingEmail: false,
      passwordResetOrigin: document.referrer.includes("/password/edit")
    };
  },
  componentDidMount: function() {
    Auth.currentUser().then((user) => {
      this.loginComplete(user);
    }).catch((error) => {
      Reskin.clearToggleUser();
      if (error.response && (error.response.status === 401 || error.response.status == 403)) {
        this.setState({ loading: false });
        this.successfulPasswordReset();
      } else {
        throw error;
      }
    });
  },
  // STATE
  loginComplete: function(user) {
    presenceService.startForUser(user);
    const location = this.props.location;
    if (location.state && location.state.nextPathname) {
      this.history.replaceState(null, location.state.nextPathname);
    } else {
      this.history.replaceState(null, "/");
    }
  },
  authenticate: function(e) {
    e.preventDefault();
    if (this.state.password == null) {
      return;
    }
    this.setState({ sending: true, loginError: null });
    Auth.login({
      email: this.state.email,
      password: this.state.password
    }).then((user) => {
      Flash.success("Logged in as " + user.display_name);
      this.loginComplete(user);
    }).catch((error) => {
      const response = error.response;
      if (response.status === 401 || response.status === 403) {
        response.json().then((json) => {
          this.setState({
            loginError: json.error,
            sending: false,
            password: null
          });
        });
      }
    });
  },
  resetPassword: function(e) {
    e.preventDefault();
    var emailMessage = "We\u2019ve sent an email to this account, if it exists. If you do not receive one, please confirm with your account administrator that you have access";
    this.setState({ sendingEmail: true });
    Auth.requestPasswordReset({
      email: this.state.email
    }).finally(() => {
      Flash.success(emailMessage);
      this.setState({
        sendingEmail: false,
        loginError: null
      });
      this.toggleResetPasswordForm();
    });
  },
  emailChanged: function(e) {
    this.setState({ email: e.target.value });
  },
  passwordChanged: function(e) {
    this.setState({ password: e.target.value });
  },
  getOktaStatus: function(e) {
    const emailAddress = this.state.email;
    this.setState({ fetchingOktaStatus: true, loginError: null }, () => {
      Auth.getOktaStatus(emailAddress).then((response) => {
        const oktaEnabled = response.oktaEnabled;
        this.setState(
          { fetchingOktaStatus: false, oktaEnabled },
          () => {
            if (oktaEnabled) {
              this.history.replaceState(null, "/okta_login", {
                e: emailAddress
              });
            } else {
              this.setState({ password: "" });
            }
          }
        );
      }).catch((_error) => {
        this.setState({
          fetchingOktaStatus: false,
          loginError: "An error occurred."
        });
      });
    });
  },
  handleEmailKeyDown: function(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      if (this.state.email > "") {
        this.getOktaStatus();
      }
    }
  },
  toggleResetPasswordForm: function() {
    this.setState({
      showPasswordReset: !this.state.showPasswordReset,
      password: null,
      loginError: null
    });
  },
  resetLoginForm: function() {
    this.setState({
      email: null,
      oktaEnabled: null,
      password: null,
      loginError: null
    });
  },
  successfulPasswordReset: function() {
    if (this.state.passwordResetOrigin) {
      Flash.success("Password successfully reset.");
      this.setState({ passwordResetOrigin: false });
    }
  },
  // RENDERING
  loginError: function() {
    let loginError;
    if (loginError = this.state.loginError) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box alert radius" }, loginError));
    }
  },
  loginEmailInput: function() {
    if (this.state.oktaEnabled != null) {
      return;
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      FormInput,
      {
        placeholder: "Email",
        onChange: this.emailChanged,
        value: this.state.email,
        id: "username_field",
        divClasses: "small-12 column",
        label: "Email",
        onKeyDown: this.handleEmailKeyDown,
        type: "email"
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        type: "button",
        onClick: this.getOktaStatus,
        disabledText: "\u2026",
        disabled: this.state.fetchingOktaStatus,
        className: "button--confirmation"
      },
      "Continue"
    )));
  },
  loginEmailLabel: function() {
    if (this.state.oktaEnabled == null) {
      return;
    }
    return /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement("label", { className: "mb-2" }, this.state.email));
  },
  loginPasswordInput: function() {
    if (this.state.oktaEnabled == null) {
      return;
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      FormInput,
      {
        placeholder: "Password",
        onChange: this.passwordChanged,
        value: this.state.password,
        id: "password_field",
        divClasses: "small-12 column",
        label: "Password",
        type: "password"
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabledText: "Signing in\u2026",
        disabled: this.state.sending,
        className: "button--confirmation"
      },
      "Sign In"
    )));
  },
  loginForm: function() {
    if (!this.state.loading && !this.state.showPasswordReset) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-6 small-centered column general-container-style" }, /* @__PURE__ */ React.createElement("h3", null, "Sign in to Triumph Audit"), /* @__PURE__ */ React.createElement("form", { onSubmit: this.authenticate, name: "loginForm" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, this.loginError(), this.loginEmailInput(), this.loginEmailLabel(), this.loginPasswordInput(), this.showPasswordResetLink(), this.showBackToSignInLink())));
    }
  },
  showPasswordResetLink: function() {
    if (this.state.email && this.state.oktaEnabled != null) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          onClick: this.toggleResetPasswordForm,
          className: "button--link-v2"
        },
        "Reset password?"
      ));
    }
  },
  showBackToSignInLink: function() {
    if (this.state.email && this.state.oktaEnabled != null) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-12 column my-2" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          onClick: this.resetLoginForm,
          className: "button--link-v2"
        },
        "Back to sign in"
      ));
    }
  },
  passwordResetForm: function() {
    if (this.state.showPasswordReset) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-6 small-centered column general-container-style" }, /* @__PURE__ */ React.createElement("h3", null, "Reset Password"), /* @__PURE__ */ React.createElement("form", { onSubmit: this.resetPassword, name: "passwordResetForm" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement(
        FormInput,
        {
          placeholder: "Email",
          onChange: this.emailChanged,
          value: this.state.email,
          id: "username_field",
          divClasses: "small-12 column",
          label: "Email",
          type: "email"
        }
      ), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledText: "Sending Email...",
          disabled: this.state.sendingEmail,
          className: "button--confirmation"
        },
        "Send Reset Email"
      )), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          onClick: this.toggleResetPasswordForm,
          className: "button--link-v2"
        },
        "Cancel"
      )))));
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { "data-component": "LoginForm", when: this.state.loading }, /* @__PURE__ */ React.createElement("div", { className: "row" }, this.loginForm(), this.passwordResetForm()));
  }
});
export default LoginForm;
